import { SET_COLLAPSED } from '../actions';
import { reduxStoreTypes } from '@type/redux-store';

const collapsed = (state = false, action: reduxStoreTypes.collapsedAction) => {
    if (action.type === SET_COLLAPSED) {
        return action.collapsed
    }
    return state
}
export default collapsed